import { render } from "./EditCompleteSectionsComponent.vue?vue&type=template&id=5471646e&scoped=true"
import script from "./EditCompleteSectionsComponent.vue?vue&type=script&lang=js"
export * from "./EditCompleteSectionsComponent.vue?vue&type=script&lang=js"

import "./EditCompleteSectionsComponent.vue?vue&type=style&index=0&id=5471646e&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5471646e"]])

export default __exports__